<template>
  <ul class="c-categoryListForSidebar">
    <li>
      <NuxtLink
        class="c-categoryListForSidebar_item"
        to="/search?pro_priority_display=1&ref=splist"
      >
        PRO認定
        <CoconalaIcon
          name="chevron-right"
          size="12px"
          color="ds2Gray600"
        />
      </NuxtLink>
    </li>
    <li v-if="!isBusiness">
      <BCollapse :open="false">
        <div
          slot="trigger"
          slot-scope="props"
          class="c-categoryListForSidebar_item"
        >
          人気のご利用シーン
          <CoconalaIcon
            :name="!props.open ? 'chevron-down' : 'chevron-up'"
            size="12px"
            color="ds2Gray600"
          />
        </div>
        <CollapseSubCategoriesUseScenes />
      </BCollapse>
    </li>
    <li
      v-for="category in categories"
      :key="category.id"
    >
      <div v-if="category.subCategories.length === 0">
        <NuxtLink
          class="c-categoryListForSidebar_item"
          :to="`/categories/${category.id}?ref=splist`"
        >
          {{ category.name }}
          <CoconalaIcon
            name="chevron-right"
            size="12px"
            color="ds2Gray600"
          />
        </NuxtLink>
      </div>
      <BCollapse
        :open="false"
        v-else
      >
        <div
          slot="trigger"
          slot-scope="props"
          class="c-categoryListForSidebar_item"
        >
          {{ category.name }}
          <CoconalaIcon
            :name="!props.open ? 'chevron-down' : 'chevron-up'"
            size="12px"
            color="ds2Gray600"
          />
        </div>
        <CollapseSubCategories
          :category="category"
          :is-business="isBusiness"
        />
      </BCollapse>
    </li>
    <li>
      <a
        class="c-categoryListForSidebar_item"
        :href="legalUrl"
        target="_blank"
        rel="noopener"
      >
        弁護士検索・法律Q&amp;A（法律相談）
        <CoconalaIcon
          name="external-link"
          size="12px"
          color="ds2Gray600"
        />
      </a>
    </li>
  </ul>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

/**
 * @type {import('vue').ComponentOptions}
 */
const categoryListForSidebar = {
  name: 'CategoryListForSidebar',
  components: {
    CollapseSubCategories: () =>
      import('./components/CollapseSubCategories' /* webpackChunkName: "CollapseSubCategories" */),
    CollapseSubCategoriesUseScenes: () =>
      import('./components/CollapseSubCategoriesUseScenes' /* webpackChunkName: "CollapseSubCategoriesUseScenes" */)
  },
  props: {
    isBusiness: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('master', ['masterCategories']),
    ...mapGetters('master', ['businessMasterCategories']),
    ...mapGetters('ui', ['isPC']),
    categories() {
      return this.isBusiness ? this.businessMasterCategories : this.masterCategories
    },
    legalUrl() {
      return this.$coconala.legalUrl('menu', this.isPC, this.isBusiness)
    }
  }
}
export default categoryListForSidebar
</script>
<style lang="scss" scoped>
.c-categoryListForSidebar {
  &_item {
    display: flex;
    padding: 8px 16px 8px 36px;
    color: $ds2-color-gray-900;
    font-size: 14px;
    line-height: 1.5;

    align-items: center;
    justify-content: space-between;
  }
}
</style>
